// extracted by mini-css-extract-plugin
export default {"buttonGroup":"ShippingDetailsPage_buttonGroup__5RCXu"};